import { render, staticRenderFns } from "./AddToCampaignGroupModal.vue?vue&type=template&id=03b3621e"
import script from "./AddToCampaignGroupModal.vue?vue&type=script&lang=js"
export * from "./AddToCampaignGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports